<template>
  <div class="grid grid-cols-7 gap-1 mx-2 justify-items-center">
    <!-- TODO: Put a loading placeholder here while the streak data loads. -->
    <!-- TODO: Make dynamic depending how many days are in the streak. -->
    <div v-for="d in streakStore.streak" :key="d" class="flex flex-row justify-center">
      <svg v-if="d.completed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="h-10 w-10 text-teal-400">
        <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd"></path>
      </svg>
      <svg v-else-if="d.completed === false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="h-10 w-10 text-gray-300">
        <circle r="7.5" cx="10" cy="10" fill="rgb(229 231 235)" stroke="currentColor" stroke-width="1" />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="h-10 w-10 text-gray-200">
        <circle r="7.5" cx="10" cy="10" fill="none" stroke="currentColor" stroke-width="1" />
      </svg>
    </div>
    <div v-for="d in streakStore.streak" :key="d" class="text-gray-500">
      {{ d.day?.split('')[0] }}
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useStreakStore } from '@/stores/streak'

export default {
  name: 'StreakComponent',
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
  computed: {
    ...mapStores(useStreakStore),
  },
}
</script>